/** Normaliza data ISO/timestamp para YYYY-MM-DD (comparação de filtro). */
export function toDateOnly(value: string | null | undefined): string {
  if (!value) return ''
  return value.slice(0, 10)
}

/**
 * Filtro de período de pagamento (payment_date).
 * Se from e to vazios, não filtra. Se qualquer limite preenchido, exige payment_date no intervalo.
 */
export function matchesPaymentDatePeriod(
  paymentDate: string | null | undefined,
  from: string,
  to: string
): boolean {
  if (!from && !to) return true
  const d = toDateOnly(paymentDate)
  if (!d) return false
  if (from && d < from) return false
  if (to && d > to) return false
  return true
}

export function isPaymentDateFilterActive(from: string, to: string): boolean {
  return Boolean(from || to)
}
